import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { User } from '../users/users.types';
import { fetchUserProfile as getUserProfile, postSignOut, postUserLogin, PostUserLoginData } from './auth.api';
import createAsyncThunkFromFetch from 'src/store/middlewares/createAsyncThunkFromFetch';

const sliceName = 'auth';

export const fetchUserProfile = createAsyncThunkFromFetch(`${sliceName}/fetchUserProfile`, getUserProfile);

export const signOut = createAsyncThunk(`${sliceName}/signOut`, async (params, thunkAPI) => {
  const response = await postSignOut();

  if (response.data.accessToken.length === 0) {
    return { user: response.data };
  }

  return thunkAPI.rejectWithValue(null);
});

export const signIn = createAsyncThunk(`${sliceName}/signIn`, async (params: PostUserLoginData, thunkAPI) => {
  const response = await postUserLogin(params);

  if (response.data.code) {
    return thunkAPI.rejectWithValue({ ...response.data });
  }

  await thunkAPI.dispatch(fetchUserProfile({}));
  return { ...response.data };
});

const initialState: {
  user: User | null;
  manager: { isPending: boolean; hasError: boolean };
} = {
  user: null,
  manager: {
    isPending: true,
    hasError: false,
  },
};

const authSlice = createSlice({
  name: sliceName,
  initialState: initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload.user;
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchUserProfile.pending, state => {
      state.manager = {
        hasError: false,
        isPending: true,
      };
      state.user = null;
    });
    builder.addCase(fetchUserProfile.fulfilled, (state, { payload }) => {
      state.user = payload;
      state.manager = { isPending: false, hasError: false };
    });
    builder.addCase(fetchUserProfile.rejected, state => {
      state.manager = { isPending: false, hasError: true };
    });
    builder.addCase(signOut.fulfilled, state => {
      state.manager = { ...initialState.manager, isPending: false };
      state.user = initialState.user;
    });
  },
});

const { actions, reducer } = authSlice;

export const { setUser } = actions;

export default reducer;
